import React, { useState } from "react";

const EnumField = React.forwardRef((props, ref) => {
    const {
        value = "",
        options = [],
        edit = false,
        freeform = false,

        className = "",
        style = {},
        width = false,
        placeholder = "",

        cell = false,
        border = false,
        right = false,
        warning = false,
        secondary = false,
        black = false,
        medium = false,
        allow_empty = true,
        dataId = "",
        autofocus = false,
        onChange = () => { },
        onPageDown = null,
        onEnter = null,
        onBlur = () => { },
        onFocus = () => { },
        onClick = () => { },
        onMouseDown = () => { },
    } = props;

    const [isFocused, setIsFocused] = useState(false);

    let _class = edit ? "ui-input edit" : "ui-input";

    if (cell) {
        _class = edit ? "ui-cell-edit" : "ui-cell";
        if (border) _class += " border";
        if (width) style.minWidth = width + "px";
    }

    if (secondary) _class += " secondary";
    if (warning) _class += " warning";
    if (black) _class += " black";
    if (medium) _class += " medium";
    if (right) _class += " ra";
    if (className) _class += ` ${className}`;
    if (width && !cell) style.width = `${width}px`;


    const selectText = (el) => {
        if (!el) return;

        requestAnimationFrame(() => {
            el.select?.();
        });
    };

    const getOptionByKey = (e) => {


        return options.find((item) => {
            if (!item?.key) return false;

            if (typeof item.key === "function") {
                return item.key(e);
            }

            if (typeof item.key === "object") {
                return (
                    item.key.key === e.key ||
                    item.key.code === e.code ||
                    item.key.keyCode === e.keyCode
                );
            }

            return item.key === e.key;
        });
    };

    const getOptionByValue = (_value) => {
        return options.find((item) => item.value === _value);
    };

    const getValueFromInput = (_inputValue) => {
        const found = options.find((item) =>
            item.value === _inputValue || item.label === _inputValue
        );

        return found?.value ?? _inputValue;
    };

    const displayValue = () => {
        const found = getOptionByValue(value);
        return found?.label ?? value;
    };

    const change = (_value, e = null) => {
        if (!freeform) {
            const found = options.find((item) => item.label === _value || item.value === _value);

            if (found) {
                onChange(found.value, found);
                selectText(e?.target);
            }

            return;
        }

        if (!allow_empty && _value === "") {
            selectText(e?.target);
            return;
        }

        onChange(_value);
        selectText(e?.target);
    };

    const handleKeyDown = (e) => {
        const found = getOptionByKey(e);

        if (found) {
            e.preventDefault();
            e.stopPropagation();

            onChange(found.value, found);
            selectText(e.target);
            return;
        }

        if (e.key === "Delete" || e.key === "Backspace") {
            if (allow_empty) {
                e.preventDefault();
                e.stopPropagation();

                onChange("", null);
                selectText(e.target);
            } else if (!freeform) {
                e.preventDefault();
                e.stopPropagation();
                selectText(e.target);
            }

            return;
        }

        if (e.key === "Enter" && onEnter) {
            e.preventDefault();
            e.stopPropagation();

            const _value = getValueFromInput(e.target.value);

            onEnter(_value, e);
            selectText(e.target);
            return;
        }

        if (e.key === "PageDown" && onPageDown) {
            e.preventDefault();
            e.stopPropagation();

            const _value = getValueFromInput(e.target.value);

            onPageDown(_value, e);
            selectText(e.target);
            return;
        }


        if (!freeform) {
            const allowed = [
                "Tab",
                "Enter",
                "Escape",
                "ArrowLeft",
                "ArrowRight",
                "ArrowUp",
                "ArrowDown",
                "Home",
                "End",
                "PageDown",
                "PageUp",
            ];

            if (!allowed.includes(e.key)) {
                e.preventDefault();
                e.stopPropagation();
            }
        }
    };

    if (edit) {
        return (
            <input
                ref={ref}
                data-id={dataId}
                autoFocus={autofocus}
                spellCheck={false}
                autoComplete="off"
                placeholder={placeholder}
                className={_class}
                style={{ ...style }}
                value={displayValue()}
                onChange={(e) => change(e.target.value, e)}
                onKeyDown={handleKeyDown}
                onFocus={(e) => {
                    setIsFocused(true);
                    selectText(e.target);
                    onFocus(e);
                }}
                onBlur={(e) => {
                    setIsFocused(false);
                    onBlur(value, e);
                }}
            />
        );
    }

    return (
        <div
            data-id={dataId}
            className={_class}
            style={{ ...style, position: "relative" }}
            onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onMouseDown(e);
            }}
            onClick={(e) => onClick(e)}
        >
            {displayValue()
                ? displayValue()
                : placeholder
                    ? <em style={{ opacity: 0.5, pointerEvents: "none" }}>{placeholder}</em>
                    : ""}
        </div>
    );
});

export default EnumField;